import fp from 'lodash/fp'

const createFormatFunction = (prop) =>
  fp.map((option) => {
    const { [prop]: id, description } = option

    return {
      id,
      name: description || fp.capitalize(id),
    }
  })

export const createFormatSportFunction = (prop) => [
  {
    id: prop,
    name: fp.capitalize(prop),
  },
]

export const formatCategories = createFormatFunction('sport')

export const getOptionLabel = fp.prop('name')

export const getOptionValue = fp.prop('id')
